export type WithdrawErrors = {
    reason?: string
    isGeneral: boolean
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null

const firstString = (value: unknown): string | undefined => {
    const first = Array.isArray(value) ? value[0] : value
    return typeof first === 'string' && first.trim() ? first : undefined
}

// Accepts a resolved response body or a rejected RTK Query error ({ status, data }).
// Returns undefined when the payload is a success.
export function parseWithdrawError(payload: unknown): WithdrawErrors | undefined {
    if (!isRecord(payload)) return undefined

    const body = isRecord(payload.data) && ('status' in payload || 'success' in payload.data) ? payload.data : payload
    const status = Number(payload.status ?? body.statusCode)
    const hasHttpError = Number.isFinite(status) && (status < 200 || status >= 300)

    if (body.success !== false && !hasHttpError && !('error' in payload)) return undefined

    const errors = isRecord(body.data) && isRecord(body.data.errors) ? body.data.errors : undefined
    const reasonFromLegacy = firstString(errors?.reason)
    const reasonFromV2 = Array.isArray(body.errors)
        ? firstString(
              (body.errors.find((e) => isRecord(e) && e.field === 'reason') as Record<string, unknown> | undefined)?.msg
          )
        : undefined
    const reason = reasonFromLegacy ?? reasonFromV2

    return { reason, isGeneral: !reason }
}
